module.exports = __webpack_public_path__ + "images/add-image-placeholder-icon.svg";